import { render } from "./HelpAoaVtBuys.vue?vue&type=template&id=46e315d5&scoped=true"
import script from "./HelpAoaVtBuys.vue?vue&type=script&lang=js"
export * from "./HelpAoaVtBuys.vue?vue&type=script&lang=js"

import "./HelpAoaVtBuys.vue?vue&type=style&index=0&id=46e315d5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46e315d5"]])

export default __exports__